<style></style>

<template>
    <div class="component-container">
        <p class="mb-4">
            Consultants are essential to Go NAPSACC’s success. 
            You serve as local ambassadors for the program, getting child care providers enrolled and providing ongoing support. 
            The resources on this page support your work with child care providers during this entire process. 
        </p>
        <how-to-row class="mb-4">
            <div slot="left">
                <!--<how-to-video :video="howToVideo"></how-to-video>-->
            </div>
            <div slot="right">
                <print-manual manualUrl="/uploads/GNS-ConsultantManual-081219.pdf">
                    <span slot="label">
                        Print/Download the TA Manual
                    </span>
                </print-manual>
            </div>
        </how-to-row>

        <BTabs justified v-model="currentTab" ref="resourcesTabs">
            <BTab title="Enrollment" active>
                <enrollment-page></enrollment-page>
            </BTab>
            <BTab title="Orientation">
                <orientation-page></orientation-page>
            </BTab>
            <BTab title="1. Assess">
                <step-1-assess></step-1-assess>
            </BTab>
            <BTab title="2. Plan">
                <step-2-plan></step-2-plan>
            </BTab>
            <BTab title="3. Take Action">
                <step-3-take-action></step-3-take-action>
            </BTab>
            <BTab title="4. Learn More">
                <step-4-learn-more></step-4-learn-more>
            </BTab>
            <BTab title="5. Keep it Up">
                <step5-keep-it-up></step5-keep-it-up>
            </BTab>
        </BTabs>
        <button 
            v-if="moreTabs"
            @click="goToNextTab()"
            class="btn btn-orange-blue float-right block mt-4"
        >
            Next Section
        </button>

    </div>
</template>

<script>
    import OrientationPage from './pages/OrientationPage'
    import Step1Assess from './pages/Step1Assess'
    import Step2Plan from './pages/Step2Plan'
    import Step3TakeAction from './pages/Step3TakeAction'
    import Step4LearnMore from './pages/Step4LearnMore'
    import EnrollmentPage from "./pages/EnrollmentPage";
    import Step5KeepItUp from "./pages/Step5KeepItUp";

    export default {
        components: {
            EnrollmentPage,
            OrientationPage,
            Step1Assess,
            Step2Plan,
            Step3TakeAction,
            Step4LearnMore,
            Step5KeepItUp,
        },
        data() {
            return {
                currentTab: 0,
                howToVideo: {
                    title: 'Watch the Consultant Resources Video', 
                    url: 'https://www.youtube.com/embed/OaLpKOVvMe8?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0'
                },
                moreTabs: true
            }
        },
        watch: {
            currentTab: function () {
                this.moreTabs = this.hasMoreTabs();
            }
        },
        methods: {
            hasMoreTabs() {
                console.log('check resourcesTabs')
                if (this.$refs.resourcesTabs && this.$refs.resourcesTabs.tabs) {
                    return this.currentTab < (this.$refs.resourcesTabs.tabs.length-1);
                }
                return true;
            },
            goToNextTab() {
                if (!this.hasMoreTabs()) {
                    return;
                }
                this.currentTab++; 
            }
        }
    }
</script>